import { PlanId } from '@/contexts/SubscriptionContext';

const CONTACT_ELIGIBLE_PLANS: Set<PlanId> = new Set(['starter', 'pro', 'business']);

interface ContactLinkVisibilityInput {
  emailCollectionEnabled?: boolean | null;
  planId?: PlanId;
}

export function shouldShowContactLink({
  emailCollectionEnabled = false,
  planId = 'free',
}: ContactLinkVisibilityInput): boolean {
  if (!CONTACT_ELIGIBLE_PLANS.has(planId)) return false;
  if (!emailCollectionEnabled) return false;
  return true;
}

export function isContactEligible(planId: PlanId): boolean {
  return CONTACT_ELIGIBLE_PLANS.has(planId);
}
